module.exports = __webpack_public_path__ + "static/2-2fc533996c79550bb9a2142a599694bf.svg";